import { useTranslation } from "react-i18next";
import FadeInUp from "./FadeInUp";

const STEPS = [
  {
    n: "01",
    title: { fr: "Créez votre organisation", en: "Create your organisation", ar: "أنشئ مؤسستك" },
    body:  { fr: "Inscrivez-vous, configurez votre entreprise, vos départements, vos sites et vos rôles en quelques minutes.", en: "Sign up, configure your company, departments, sites and roles in minutes.", ar: "سجّل واضبط شركتك وأقسامها ومواقعها وأدوارها في دقائق." },
  },
  {
    n: "02",
    title: { fr: "Recrutez et intégrez", en: "Recruit and onboard", ar: "وظّف وألحق" },
    body:  { fr: "Publiez vos offres, gérez les candidatures et guidez chaque recrue à travers un parcours d'intégration structuré.", en: "Post job offers, manage applications and guide each hire through a structured onboarding journey.", ar: "انشر الوظائف وأدر الطلبات وارشد كل موظف جديد خلال رحلة إلحاق منظمة." },
  },
  {
    n: "03",
    title: { fr: "Gérez présence & congés", en: "Manage attendance & leave", ar: "أدر الحضور والإجازات" },
    body:  { fr: "Pointage biométrique, planning par équipes, demandes de congés et circuits d'approbation — en temps réel.", en: "Biometric attendance, shift scheduling, leave requests and approval workflows — all in real time.", ar: "الحضور البيومتري وجداول الفرق وطلبات الإجازات ودوائر الموافقة — في الوقت الفعلي." },
  },
  {
    n: "04",
    title: { fr: "Analysez et développez", en: "Analyse and develop", ar: "حلّل وطوّر" },
    body:  { fr: "Tableaux de bord RH, évaluations de performance, paie automatisée et plans de développement des talents.", en: "HR dashboards, performance reviews, automated payroll and talent development plans.", ar: "لوحات معلومات الموارد البشرية وتقييمات الأداء والرواتب الآلية وخطط تطوير المواهب." },
  },
];

const LandingHowItWorks = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const t = (obj) => obj[lang] || obj.fr;

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: "#0f1011", borderTop: "1px solid #23252a", borderBottom: "1px solid #23252a" }}>
      <div className="max-w-7xl mx-auto">
        <FadeInUp>
          <div style={{ textAlign: "center", maxWidth: "480px", margin: "0 auto 64px" }}>
            <span
              style={{
                display: "inline-block",
                fontSize: "12px",
                fontWeight: 500,
                letterSpacing: "0.4px",
                textTransform: "uppercase",
                padding: "4px 14px",
                borderRadius: "9999px",
                color: "#5e6ad2",
                backgroundColor: "rgba(94,106,210,0.10)",
                border: "1px solid rgba(94,106,210,0.20)",
                marginBottom: "20px",
              }}
            >
              {t({ fr: "Mise en route", en: "Getting started", ar: "البدء" })}
            </span>
            <h2
              style={{
                color: "#f7f8f8",
                fontSize: "clamp(28px, 4vw, 40px)",
                fontWeight: 600,
                lineHeight: 1.15,
                letterSpacing: "-1.0px",
              }}
            >
              {t({ fr: "Opérationnel en moins d'une journée", en: "Up and running in under a day", ar: "جاهز للعمل في أقل من يوم" })}
            </h2>
          </div>
        </FadeInUp>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((step, i) => (
            <FadeInUp key={i} delay={i * 0.08}>
              <div style={{ position: "relative" }}>
                {/* Connector line on desktop */}
                {i < STEPS.length - 1 && (
                  <div
                    className="hidden lg:block"
                    style={{
                      position: "absolute",
                      top: "18px",
                      left: "calc(100% - 12px)",
                      width: "calc(100% - 12px)",
                      height: "1px",
                      backgroundColor: "#23252a",
                      zIndex: 0,
                    }}
                  />
                )}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(94,106,210,0.12)",
                    border: "1px solid rgba(94,106,210,0.25)",
                    marginBottom: "16px",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  <span style={{ color: "#5e6ad2", fontSize: "11px", fontWeight: 600, letterSpacing: "0.2px" }}>{step.n}</span>
                </div>

                <div style={{ color: "#f7f8f8", fontSize: "15px", fontWeight: 500, letterSpacing: "-0.3px", marginBottom: "8px" }}>
                  {t(step.title)}
                </div>
                <p style={{ color: "#8a8f98", fontSize: "14px", lineHeight: 1.5 }}>
                  {t(step.body)}
                </p>
              </div>
            </FadeInUp>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingHowItWorks;
